// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  src/features/estoque/hooks/useLotes.ts
// ════════════════════════════════════════════════════════════════════════════

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { lotesService } from '../services/lotesService';
import type { CriarLoteRequest, AtualizarLoteRequest } from '../types';

interface UseLotesParams {
  produtoId?: number;
  pagina?: number;
  tamanhoPagina?: number;
  status?: string;
  busca?: string;
  venceEmDias?: number;
  comSaldo?: boolean;
}

export const useLotes = (params: UseLotesParams = {}) => {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: ['lotes', params],
    queryFn: () => lotesService.listar(params),
  });

  const criar = useMutation({
    mutationFn: (req: CriarLoteRequest) => lotesService.criar(req),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['lotes'] }),
  });

  const atualizar = useMutation({
    mutationFn: ({ id, req }: { id: number; req: AtualizarLoteRequest }) =>
      lotesService.atualizar(id, req),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['lotes'] }),
  });

  const excluir = useMutation({
    mutationFn: (id: number) => lotesService.excluir(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['lotes'] }),
  });

  return { query, criar, atualizar, excluir };
};
